// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBrHleez422jqBwH04mKCmOuKcpJC-Ntw0",
  authDomain: "griddl.firebaseapp.com",
  projectId: "griddl",
  storageBucket: "griddl.appspot.com",
  messagingSenderId: "769734890831",
  appId: "1:769734890831:web:a2bda1c099b0fdda18e13a",
  measurementId: "G-4R0D3YZENK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const analytics = getAnalytics(app);
export { db, analytics }